// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiHistorique.js
//  WikiHistorique
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { THEME } from "../../socle/theme";
import { wBtnSm, wGhostSm, wPanel } from "./styles";
import { WikiContenu } from "./WikiContenu";

// ═══════════════ Historique ═══════════════
export function WikiHistorique({ api, page, onRetour, onRestaure, droits }) {
  const [d, setD] = useState(null);
  const [vue, setVue] = useState(null);
  const [erreur, setErreur] = useState("");

  const charger = useCallback(() => api.versions(page.id).then(setD).catch((e) => setErreur(e.message)), [api, page]);
  useEffect(() => { charger(); }, [page.id, charger]);

  const restaurer = async (v) => {
    if (!window.confirm(`Restaurer la version ${v} ? Une nouvelle version sera créée — rien n'est perdu.`)) return;
    try { await api.restaurer(page.id, v); onRestaure(); } catch (e) { setErreur(e.message); }
  };

  if (vue) return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <button onClick={() => setVue(null)} style={wGhostSm}>← Historique</button>
        <h2 style={{ color: THEME.text, fontSize: 17, fontWeight: 800, margin: 0 }}>
          Version {vue.version.version} — {vue.version.titre}
        </h2>
        {droits.publier && (
          <button onClick={() => restaurer(vue.version.version)} style={{ ...wBtnSm(THEME.accentDim, THEME.accent, THEME.accent), marginLeft: "auto" }}>
            ↩ Restaurer cette version
          </button>
        )}
      </div>
      <div style={wPanel}><WikiContenu html={vue.html} onChip={() => {}} /></div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <button onClick={onRetour} style={wGhostSm}>← Retour à la page</button>
        <h2 style={{ color: THEME.text, fontSize: 17, fontWeight: 800, margin: 0 }}>🕘 Historique — {page.titre}</h2>
      </div>
      <div style={{ background: THEME.goldDim, border: `1px solid ${THEME.gold}`, color: THEME.gold, borderRadius: 10, padding: "10px 14px", fontSize: 12.5 }}>
        Restaurer une version ancienne <b>crée une nouvelle version</b> : rien n'est jamais perdu.
      </div>
      {erreur && <div style={{ color: THEME.red, fontSize: 12.5 }}>{erreur}</div>}
      {!d && <div style={{ color: THEME.textMuted }}>Chargement…</div>}
      {d && d.versions.map((v) => (
        <div key={v.id} style={{ background: THEME.panel, border: `1px solid ${v.version === d.courante ? THEME.emerald : THEME.border}`, borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <b style={{ color: THEME.text, width: 44 }}>v{v.version}</b>
          <div style={{ flex: 1, minWidth: 180 }}>
            <div style={{ color: THEME.text, fontSize: 13 }}>{v.commentaire || v.titre}</div>
            <div style={{ color: THEME.textDim, fontSize: 11 }}>
              {v.auteur || "—"} · {new Date(v.created_at).toLocaleString("fr")}
            </div>
          </div>
          {v.version === d.courante
            ? <Badge text="actuelle" bg={THEME.emeraldDim} color={THEME.emerald} />
            : (
              <>
                <button onClick={async () => setVue(await api.version(v.id))} style={wGhostSm}>Voir</button>
                {droits.publier && <button onClick={() => restaurer(v.version)} style={wBtnSm(THEME.accentDim, THEME.accent, THEME.accent)}>Restaurer</button>}
              </>
            )}
        </div>
      ))}
    </div>
  );
}
